import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiRSelect, UiItemSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

import { Table } from 'antd';
import { getStorage, setStorage, updateFilterUrl } from "../../helper.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";
import ExportPDFButton from '../../pdf_table.js';


export default function ItemGroups() {
  let navigate = useNavigate();
  const [fy] = useOutletContext();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [pagenum, setPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);
  const [initialLoad, setInitLoad] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: getStorage('perpage') ? [20, 50, 100].includes(parseInt(getStorage('perpage'))) ? parseInt(getStorage('perpage')) : 20 : 20,
      showSizeChanger: true,
      pageSizeOptions: [20, 50, 100],
    },

  });


  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])
    setPage(1)
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'item-groups', 1), { replace: location.search ? true : false })


  };
  useEffect(() => {
    queryClient.invalidateQueries(['item_groups'])
  }, [fy]);


  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .get("/update_item_group?delete=" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.data.status == 'success') {
          queryClient.invalidateQueries(['item_groups'])
          clearSelection()
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }



  const headers = [
    { label: "Name", key: "name" },
  ];


  const pdf_columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },


  ];


  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/item_groups" + filter
    );

    var dataa = data;
    return dataa;
  }

  const defaultValues = {
    search: null,
    item: null,
  };

  const clearFilter = () => {
    setSelectedRowKeys([])
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    reset(defaultValues)
    navigate(updateFilterUrl({}, 'item-groups', 1), { replace: true })
  }



  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      onClick: () => addGroup(e.id, e),
    },
    {
      key: '2',
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];


  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
      //setPage(parseInt(parsed.page))
    } else {
      setPage(1)
      setFilter(defaultValues)
    }



  }, [location]);

  const groupModal = useModal('item_group');

  const addGroup = (id, row) => {
    groupModal.show({ id: id, data: row }).then((res) => {
      queryClient.invalidateQueries(['item_groups'])
    });


  }

  useEffect(() => {


    const parsed = queryString.parse(location.search);

    if (parsed.page) {
      setPage(parseInt(parsed.page))
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: parseInt(parsed.page),
        },
      });
    } else {
      // setPage(1)
    }

    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'Name',
      width: '230px',
      dataIndex: 'name',
      sorter: 'name',
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
    },
    

    {
      title: '',
      fixed: 'right',
      width: '40px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
            items: items(row),
          }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>


          </Dropdown>

        </div>


      )
    },

  ];


  useEffect(() => {

    var set_perpage = 0;
    if (location.search) {
      const parsed = queryString.parse(location.search);
      if (parsed.perpage) {
        if ([20, 50, 100].includes(parseInt(parsed.perpage))) {
          setInitLoad(true)
        } else {
          setStorage('perpage', 20)
          set_perpage = 1;
        }

      } else {
        set_perpage = 1;
      }

    } else {
      set_perpage = 1;
    }

    if (set_perpage == 1) {


      navigate(updateFilterUrl(window.location.search, 'item-groups', 1), { replace: true })
    }

  }, [location.search]);

  const { data, error, isError, isLoading, isFetching } = useQuery(["item_groups", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
    enabled: initialLoad
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        search: filter.search,
        item: filter.item && parseInt(filter.item),
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {
    if (data) {
      const parsed = queryString.parse(location.search);
      var setpage = 1;
      if (parsed.page) {
        setpage = parseInt(parsed.page);
      }
      if (parsed.page && parseInt(parsed.page) > 1 && data.items.length == 0) {
        let currentUrlParams = new URLSearchParams(window.location.search);

        setpage = Math.ceil(data.total / parseInt(tableParams.pagination.pageSize));
        setPage(setpage)

        currentUrlParams.set('page', setpage);

        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });

        navigate('/item-groups?' + currentUrlParams.toString(), { replace: true })
      } else {
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });
      }
    }

  }, [data]);

  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }
    var pg = pagination.current
    setPage(pg)
    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }

    currentUrlParams.set('page', pg);
    var perpage = pagination.pageSize
    currentUrlParams.set('perpage', perpage);
    setStorage('perpage', perpage)
    if (location.search) {
      navigate('/item-groups?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/item-groups?' + currentUrlParams.toString())
    }

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });


  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };

  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Item Groups
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Item Groups" >

            {data.items &&
              <><ExportPDFButton columns={pdf_columns} data={data.items} title="item-groups" />
                <CSVLink data={data.items} filename={"Item-Groups.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }
            <UiButton className="btn btn-primary" onClick={() => addGroup('new')} title="Add" icon="add"></UiButton>


          </PageHeader>
          <div className="position-relative bg-white rounded mb-4">


          <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
            <div className="p-3 pb-0">

              <div className="row">

                <div className="col">
                  <UiInput
                    label="Search"
                    type="text"

                    name="search"

                    {...register("search")}
                  />
                </div>



                <div className="col-md-3">
                <Controller
                      name={`item`}
                      control={control}
                      render={({ field }) => (

                        <UiItemSelect
                          {...field}
                          parentClass="mb-1"
                          className=""
                          fetch_onload
                          message={errors.item?.message}
                          label="Item"

                        />

                      )}
                    />
                </div>



                <div className={`col-md-3`}>

                </div>











                <div className="col-md-2" style={{ paddingTop: '28px', minWidth: '200px' }}>
                  <div className="d-flex justify-content-end">
                  <UiButton type="" className="ms-2 btn-light" title="Clear" onClick={() => clearFilter()} />
                  <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                  </div>

                </div>
              </div>



            </div>
          </form>

    
              <Table
                locale={{
                  emptyText: (<TableZero title="Item Group" />)
                }}

                size="small"
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={data.items}
                pagination={{ ...tableParams.pagination, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` }}
                loading={{ spinning: (tableDisable || isFetching) }}
                onChange={handleTableChange}
                scroll={{
                  x: 960,

                }}
              />

          </div>
        </div>
      </div>
    </>
  );
}
